import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calculateTotal',
})
export class CalculateTotalPipe implements PipeTransform {
  transform<T>(value: T[], args: keyof T): number {
    return value.reduce((pre, curr: T) => {
      const { startTerm, endTerm } = curr as any;
      const count = startTerm === endTerm ? 1 : (endTerm - startTerm) + 1;
      return (pre += (curr as any)[args] * count);
    }, 0);
  }
}
